"use client";

import { useState } from "react";
import Image from "next/image";
import { SceneTemplate, SceneTemplateVariation } from "@/lib/utils/lomda/types";
import { calcA4Width, calcBorderRadius } from "./utils";
import { t } from "@/lib/localization";

interface SceneSlideFrameProps {
    templateOverride?: SceneTemplateVariation;
    templateConfig: SceneTemplate;
    sceneImage?: string;
    thumbnail?: boolean;
}
export default function SceneSlideFrame({
    templateOverride,
    templateConfig,
    sceneImage = "",
    thumbnail = false,
}: SceneSlideFrameProps) {
    const sceneConfig = templateConfig.scene;
    const isA4 = templateConfig.aspectRatio === "1:1.414";
    const a4Width = isA4 ? calcA4Width(sceneConfig.scale) : sceneConfig.scale;

    const slideFrameTransform = {
        width: `${a4Width}%`,
        height: `${sceneConfig.scale}%`,
        top: `${sceneConfig.location.y}%`,
        right: `${sceneConfig.location.x}%`,
        borderRadius: sceneConfig.rounded
            ? calcBorderRadius(a4Width, sceneConfig.scale)
            : "0",
        aspectRatio: templateConfig.aspectRatio.replace(":", "/"),
    };

    const thumbnailUrl = sceneImage
        ? sceneImage.replace(".png", "-thumb.png")
        : "/images/slide-placeholder.webp";

    const [thumbnailFailed, setThumbnailFailed] = useState(false);
    const imageSrc = thumbnail && !thumbnailFailed ? thumbnailUrl : sceneImage;
    const handleImageError = () => {
        if (thumbnailUrl) {
            setThumbnailFailed(true);
        }
    };

    return (
        <>
            {sceneImage && imageSrc ? (
                templateOverride !== "none" ? (
                    <div
                        className="relative overflow-hidden"
                        style={slideFrameTransform}
                    >
                        <Image
                            src={imageSrc}
                            alt={t("lomda.scene")}
                            fill
                            className="object-cover h-full"
                            priority={true}
                            unoptimized={true}
                            onError={handleImageError}
                        />
                    </div>
                ) : (
                    <Image
                        src={imageSrc}
                        alt={t("lomda.scene")}
                        fill
                        className="object-cover h-full"
                        priority={true}
                        unoptimized={true}
                        onError={handleImageError}
                    />
                )
            ) : (
                <div
                    className="relative w-full h-full border"
                    style={slideFrameTransform}
                />
            )}
        </>
    );
}
